module.exports = __webpack_public_path__ + "static/media/Product perf image.109b14eb.png";